import script from "./recent-conversations.vue?vue&type=script&setup=true&lang=js"
export * from "./recent-conversations.vue?vue&type=script&setup=true&lang=js"

import "./recent-conversations.vue?vue&type=style&index=0&id=1e57a39d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e57a39d"]])

export default __exports__